var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown",
    { attrs: { dropdown: "", text: "My profile", variant: "link" } },
    [
      _c("b-dropdown-item", { attrs: { to: "/profile" } }, [_vm._v("My data")]),
      _vm._v(" "),
      _c("b-dropdown-item", { attrs: { to: "/subscription" } }, [
        _vm._v("My subscription"),
      ]),
      _vm._v(" "),
      _c("b-dropdown-item", { on: { click: _vm.onLogout } }, [
        _vm._v("Logout"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }